import React from 'react'

export default function ToggleDescItem({ item, descToggle, selected }) {
  const isSelected = selected.index === item.index ? 'isActive' : '';
  return (
    <div
      className={`toggleDesc__left--item ${isSelected}`}
      onClick={ () => descToggle(item) }
    >
      <h1>{item.index}</h1>
      <h3>{item.title}</h3>
    </div>
  )
}
